import { render, staticRenderFns } from "./TkFavoriteButton.vue?vue&type=template&id=bf3d5986&"
import script from "./TkFavoriteButton.vue?vue&type=script&lang=js&"
export * from "./TkFavoriteButton.vue?vue&type=script&lang=js&"
import style0 from "./TkFavoriteButton.vue?vue&type=style&index=0&id=bf3d5986&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports